import { Injectable } from '@angular/core';
import { ILoginReminder } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder';
import { FiLoginReminderTimePeriodType } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-enums';
import { ITabItem } from '@fi-app/utilities/tabs/tabs';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Injectable()
export class FiLoginReminderHelperService {
    constructor(
        private stateAccessCheckService: StateAccessCheckService,
        private appTextService: AppTextService,
    ) {}

    getLoginReminderSettingsTabs(loginReminder: ILoginReminder): ITabItem[] {
        const tabs: ITabItem[] = [];
        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.TaskV2.Current)) {
            tabs.push({
                Title: this.appTextService.get('login.reminder_overview'),
                Sref: FiStateNames.OtherSettings.LoginReminder.Overview,
                SrefParams: { loginReminder: loginReminder },
            });

            tabs.push({
                Title: this.appTextService.get('login.sent_reminders'),
                Sref: FiStateNames.OtherSettings.LoginReminder.Log,
                SrefParams: { loginReminder: loginReminder },
            });
        }
        return tabs;
    }

    getNewInstance(): ILoginReminder {
        return {
            IsEnabled: false,
            InitialPeriod: {
                Value: 4,
                Type: FiLoginReminderTimePeriodType.Weeks,
                Hours: 8,
                Minutes: 0,
            },
            RepeatedPeriod: {
                Value: 7,
                Type: FiLoginReminderTimePeriodType.Days,
                Hours: 8,
                Minutes: 0,
            },
            NumberOfRepeated: 3,
            ViaEmail: true,
            ViaSMS: false,
            Message: '',
            IsDefaultMessage: true,
        };
    }
}
